export default "__VITE_ASSET__B7D0CHnH__"